var map = {
	"./athletes-ic.png": 910,
	"./balanced-ic.png": 911,
	"./keto-ic.png": 912,
	"./vegan-ic.png": 913,
	"./vegetarian-ic.png": 914,
	"./weight-loss-ic.png": 915
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 473;